<form (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <h1 mat-dialog-title>{{ 'subscriptions.payment-methods.alert.title.' + status | lowercase | transloco }}</h1>
    <rma-callout [theme]="status === PaymentMethodAlertStatus.Expiring ? 'caution' : 'error'">
      <span [innerHtml]="'subscriptions.payment-methods.alert.message.' + status | lowercase | transloco"></span>
    </rma-callout>

    <rma-stripe-payment-element
      [clientSecret]="clientSecret$ | async"
      (loaded)="onStripeElementLoaded($event)"
      (changed)="onStripeElementChanged($event)"
    />

    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" (click)="remindMe()" mat-button color="primary">
      {{ 'subscriptions.payment-methods.alert.reminder' | transloco }}
    </button>

    <button type="submit" [disabled]="isSubmitting || !isComplete" mat-flat-button color="primary">
      <span>{{ 'subscriptions.payment-methods.alert.submit' | transloco }}</span>
      @if (isSubmitting) {
        <mat-spinner diameter="30" />
      }
    </button>
  </mat-dialog-actions>
</form>
